<p class="{{classLabel}}" [innerHTML]="label"></p>
<mclu-input-date-mobile *ngIf="!plateforme.isDesktop()" [fc]="fc"></mclu-input-date-mobile>
<mclu-input-date-desktop *ngIf="plateforme.isDesktop()" [fc]="fc" [ageMin]="ageMin"></mclu-input-date-desktop>
